import React, { useRef, useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ImageUploader = ({ currentUrl, onFileSelect, acceptTypes }) => {
  const { resolvedTheme } = useTheme();
  const dark = resolvedTheme === 'dark';
  const fileRef = useRef();
  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = '';

    const allowed = acceptTypes || ['image/png', 'image/jpeg', 'image/webp'];
    if (!allowed.includes(file.type)) {
      const names = allowed.map(t => t.split('/')[1].toUpperCase()).join(', ');
      alert('Only ' + names + ' images are allowed.');
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      alert('Image must be under 2MB.');
      return;
    }

    setPreview(URL.createObjectURL(file));
    onFileSelect(file);
  };

  const imgSrc = preview || currentUrl;

  return (
    <div className="flex items-center gap-3">
      <input
        ref={fileRef}
        type="file"
        accept={acceptTypes ? acceptTypes.join(',') : 'image/png,image/jpeg,image/webp'}
        className="hidden"
        onChange={handleFileChange}
      />
      {imgSrc ? (
        <img src={imgSrc} alt="" className="w-12 h-12 rounded object-cover" />
      ) : (
        <div className={`w-12 h-12 rounded flex items-center justify-center ${dark ? 'bg-[#333]' : 'bg-gray-200'}`}>
          <svg className={`w-5 h-5 ${dark ? 'text-gray-500' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
      )}
      <button
        type="button"
        onClick={() => fileRef.current?.click()}
        className={`px-3 py-1.5 rounded-lg text-xs font-medium border ${
          dark ? 'border-[#333] text-gray-300 hover:bg-[#333]' : 'border-gray-300 text-gray-600 hover:bg-gray-50'
        }`}
      >
        Choose Image
      </button>
    </div>
  );
};

export default ImageUploader;
